import { useAuth0 } from '@auth0/auth0-react';
import { Button, Modal } from '@mui/material';
import './styles.scss';

import { ConnectionErrorVariant } from '../../global-provider';

interface INetworkConnectionModal {
  open: boolean;
  handleClose: () => void;
  variant?: ConnectionErrorVariant;
}

export const NetworkConnectionModal = ({
  open,
  handleClose,
  variant = 'network',
}: INetworkConnectionModal) => {
  const { logout } = useAuth0();

  const handleReloadPage = () => {
    window.location.reload();
    handleClose();
  };

  const handleReturnToLogin = () => {
    logout({ logoutParams: { returnTo: import.meta.env.REACT_APP_AUTH0_LOGOUT } });
    handleClose();
  };

  if (variant === 'access') {
    return (
      <Modal open={open} onClose={handleClose}>
        <div className="network-connection-modal-container">
          <div className="network-connection-modal-content">
            <div className="network-connection-modal-header">
              <h1>Access not available</h1>
            </div>

            <div className="network-connection-modal-description">
              <span>
                Your account may not have access to this environment. Please contact your
                administrator.
              </span>
            </div>

            <div className="network-connection-modal-button-area">
              <Button
                className="network-connection-modal-save-button"
                onClick={handleReturnToLogin}
              >
                Return to login
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="network-connection-modal-container">
        <div className="network-connection-modal-content">
          <div className="network-connection-modal-header">
            <h1>Network Connection Failed</h1>
          </div>

          <div className="network-connection-modal-description">
            <span>
              Please refresh this page. <br /> If the problem persists, check your internet
              connection and try again.
            </span>
          </div>

          <div className="network-connection-modal-button-area">
            <Button className="network-connection-modal-save-button" onClick={handleReloadPage}>
              Refresh page
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
